module.exports = __webpack_public_path__ + "img/buenos_aires_belgrano.5e50ba64.jpg";